export const extension = extension => ({
  type: 'CREDUX_EXTENSION',
  extension
})

export const authorised = authorised => ({
  type: 'CREDUX_AUTHORISED',
  authorised
})